import { AxiosError } from 'axios';
import { createDosageDiaryProfileParams } from '../interface/interface';
import instance from '../config/axios';

export const createDosageDiaryProfile = async (
  token: string,
  params: createDosageDiaryProfileParams,
) => {
  try {
    const fd = new FormData();
    fd.append('name', params.name);
    fd.append('file', params.file);

    const response = await instance({
      method: 'POST',
      url: '/api/v1/dosasgedairy/profile',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
      data: fd,
    });

    return response.status;
  } catch (e) {
    return ((e as AxiosError).response?.data as { message: string }).message;
  }
};
